// ABOUTME: Route guard that redirects away when the current user's role isn't in the allowed list.
import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { AdminRole } from '../../../types/adminRoles';
import { useCurrentRole } from '../hooks/useRole';

interface RequireRoleProps {
  allowed: AdminRole[];
  children: ReactNode;
}

export const RequireRole = ({ allowed, children }: RequireRoleProps) => {
  const role = useCurrentRole();

  if (!role || !allowed.includes(role)) {
    return <Navigate to="/admin" replace />;
  }

  return <>{children}</>;
};
